import React, { useContext, useEffect } from "react";

import ShipmentInformation from "./information/index";
import ShipmentResources from "./resources";
import ShipmentBins from "./bins";
import ShipmentUpcs from "./upcs";
import Measurements from "./measurements";
import TaskNav from "components/task-nav/task-nav";
import UtilityNav from "./components/utility-nav";
import Shipment from "./contexts/shipment";
import Upcs from "./contexts/upcs";
import { Notes } from "./notes";
import { useAlert } from "hooks/useAlert";
import { SettingsContext } from "contexts/settings";
import { ViewOnlyPermissionsContext } from "contexts/view-only-permissions/view-only-permissions";
import { useParams } from "react-router-dom";

const ShipmentEditorIndex = (props) => {
    const { id: shipmentKey } = useParams();
    const { toggleAlert } = useAlert();
    const { settings } = useContext(SettingsContext);
    const { handleShipmentCheck, viewOnlyShipment } = useContext(ViewOnlyPermissionsContext);

    useEffect(() => {
        handleShipmentCheck(true);
    }, []);

    useEffect(() => {
        if (settings.globalNotifications.messages.length) {
            toggleAlert();
        }
    }, [settings.globalNotifications.messages.length]);

    return (
        <div className="container">
            <Shipment shipmentKey={shipmentKey}>
                <TaskNav>
                    <UtilityNav />
                </TaskNav>
                <ShipmentInformation />
                <Notes />
                <ShipmentResources id={shipmentKey} disableAdd={viewOnlyShipment.disableAddPaperwork} />
                <ShipmentBins />
                <Upcs shipmentKey={shipmentKey}>
                    <ShipmentUpcs shipmentKey={shipmentKey} />
                    <Measurements shipmentKey={shipmentKey} />
                </Upcs>
            </Shipment>
        </div>
    );
};

export default ShipmentEditorIndex;
